var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMedication(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BoxContent/Header/LeftIcon10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BoxContent/Header/LeftIcon10",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BoxContent/Header/LeftIcon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F5F5F7",
    opacity: 0,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4423141,9.07494659 L18.4418683,11.6473149 C19.9752852,12.6336828 20.4599822,14.7481248 19.521412,16.3605473 C18.9238654,17.3868862 17.8832453,18 16.7367504,18 C16.1382074,18 15.550689,17.8261617 15.0381893,17.496156 L15.0381893,17.496156 L10.773241,14.7546458 L10.7852942,14.6502752 C10.8929689,13.7044865 11.287637,11.7281692 12.7002332,10.2784013 C12.725368,10.3335768 16.6760668,12.8979036 16.6760668,12.8979036 C16.7270436,12.9305426 16.7825844,12.9455444 16.8374503,12.9455444 C16.9415252,12.9455444 17.043543,12.8900648 17.1013981,12.7895798 C17.1910413,12.6362845 17.1447573,12.4363281 16.999091,12.3422291 L16.999091,12.3422291 L13.1472923,9.87044709 C13.5011083,9.57946636 13.9019476,9.31791482 14.3682275,9.10812623 L14.3682275,9.10812623 L14.4423141,9.07494659 Z M7.41243914,5 C8.03888114,5 8.65359142,5.18225152 9.18904023,5.52725898 L9.18904023,5.52725898 L13.6630704,8.40422452 L12.9350606,8.86968557 C11.0453528,10.0794924 10.3165073,12.1174387 10.0379672,13.6143068 L10.0379672,13.6143068 L9.89400445,14.3859531 L5.63002039,11.6436658 C4.0260203,10.6118195 3.51908118,8.40071058 4.50007843,6.71425898 C5.12484907,5.64112394 6.21364963,5 7.41243914,5 Z M7.41243914,6.0932388 C6.57906878,6.0932388 5.82155286,6.53890018 5.38780043,7.28503667 C4.70546399,8.45689973 5.05748004,9.99377264 6.17221896,10.7109868 L6.17221896,10.7109868 L9.18704745,12.6488536 C9.5281996,11.3603549 10.2392707,9.67177469 11.7166003,8.43385644 L11.7166003,8.43385644 L8.64677738,6.45936365 C8.27364422,6.2200445 7.84696297,6.0932388 7.41243914,6.0932388 Z",
    id: "Combined-Shape",
    fill: "#181E34",
    fillRule: "nonzero",
    opacity: 0.400000006
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMedication);
export default __webpack_public_path__ + "static/media/icon-medication.f7f1a54ef0f54ccc5d900041b4832478.svg";
export { ForwardRef as ReactComponent };